const homeDescription = {
  zh: 'Pet Days 是免費的寵物紀念日與日期計算工具，讓你輸入狗狗、貓咪或其他毛孩的生日、領養日、回家日或自訂紀念日，即時查看相處總天數、精確年月日差距、已解鎖成就及下一個重要里程碑，並建立可分享的專屬連結；網站亦提供工作日計算、中英文介面與寵物照護知識，協助主人有系統地保存、回顧及分享與毛孩共度的每個珍貴時刻。',
  en: 'Pet Days is a free bilingual pet anniversary and date calculator for tracking birthdays, adoption days, time together, achievements, and upcoming milestones, with precise date differences and shareable links.'
};

const pageContent = {
  '/about': {
    zh: {
      title: '關於 Pet Days｜寵物紀念日工具的使命、理念與開發團隊',
      description: '了解 Pet Days 寵物紀念日計算器的創作理念、服務使命及 Homy Tech Limited 團隊如何協助主人記錄與毛孩相處的珍貴時光。'
    },
    en: {
      title: 'About Pet Days | Our Mission, Values and Development Team',
      description: 'Learn why Homy Tech Limited created Pet Days and how our team helps pet owners preserve anniversaries, milestones, and meaningful memories with their pets.'
    }
  },
  '/features': {
    zh: {
      title: 'Pet Days 功能介紹｜寵物紀念日、成就與里程碑追蹤工具',
      description: '探索 Pet Days 的寵物紀念日計算、精確日期差、成就解鎖、里程碑追蹤、社交分享及多種寵物與紀念類型功能。'
    },
    en: {
      title: 'Pet Days Features | Anniversaries, Achievements and Milestones',
      description: 'Explore Pet Days features for calculating pet anniversaries, tracking milestones, unlocking achievements, sharing results, and supporting different pets and occasions.'
    }
  },
  '/help': {
    zh: {
      title: 'Pet Days 使用幫助｜寵物紀念日計算與分享常見問題指南',
      description: '查看 Pet Days 使用指南與常見問題，了解如何選擇寵物日期、建立自訂紀念日、查看成就與里程碑，以及分享計算結果。'
    },
    en: {
      title: 'Pet Days Help Center | Calculator and Sharing Guide',
      description: 'Find answers about selecting pet dates, creating custom anniversaries, viewing achievements and milestones, changing languages, and sharing Pet Days results.'
    }
  },
  '/contact': {
    zh: {
      title: '聯絡 Pet Days｜功能建議、錯誤回報與寵物工具服務查詢',
      description: '聯絡 Pet Days 團隊提出功能建議、錯誤回報、合作查詢或一般意見，亦可前往使用幫助頁面查看常見問題解答。'
    },
    en: {
      title: 'Contact Pet Days | Suggestions, Bug Reports and Support',
      description: 'Contact the Pet Days team with feature suggestions, bug reports, collaboration enquiries, or general feedback, and visit our help center for common answers.'
    }
  },
  '/privacy': {
    zh: {
      title: 'Pet Days 隱私政策｜寵物資料、使用資訊與安全保護說明',
      description: '閱讀 Pet Days 隱私政策，了解網站如何處理你輸入的寵物日期、名稱、使用資料、裝置資訊與 Cookie，以及相關資料權利。'
    },
    en: {
      title: 'Pet Days Privacy Policy | Data Use, Cookies and Security',
      description: 'Read how Pet Days handles pet details, usage information, device data, cookies, security measures, information sharing, and your privacy rights.'
    }
  },
  '/terms': {
    zh: {
      title: 'Pet Days 使用條款｜服務規則、用戶責任與法律資訊說明',
      description: '閱讀 Pet Days 使用條款，了解服務內容、用戶責任、知識產權、免責聲明、責任限制、外部連結及適用法律。'
    },
    en: {
      title: 'Pet Days Terms of Service | Usage Rules and Legal Information',
      description: 'Review the Pet Days service terms covering user responsibilities, intellectual property, disclaimers, liability limitations, external links, and governing law.'
    }
  }
};

export function getPageSEO(pathname, language, activeTab) {
  const lang = language === 'zh' ? 'zh' : 'en';

  if (pathname === '/') {
    if (activeTab === 'standard') {
      return {
        title: lang === 'zh'
          ? 'Pet Days 日期計算器｜精確計算日期差、總天數與工作日'
          : 'Pet Days Date Calculator | Days and Workdays Between Dates',
        description: lang === 'zh'
          ? 'Pet Days 日期計算器可精確計算任意兩個日期之間的總天數、工作日及年、月、日差距，適合規劃活動、合約期限、假期、倒數日與重要行程；只需選擇開始及結束日期即可即時取得結果，並可切換中英文介面使用。'
          : 'Use the free Pet Days date calculator to find total days, workdays, and precise year, month, and day differences between any two selected dates.',
        canonicalPath: '/#/?tab=standard'
      };
    }

    return {
      title: lang === 'zh'
        ? 'Pet Days 寵物紀念日計算器｜領養日、生日與成長里程碑追蹤工具'
        : 'Pet Days | Pet Anniversary and Milestone Calculator',
      description: homeDescription[lang],
      canonicalPath: '/#/'
    };
  }

  const page = pageContent[pathname]?.[lang] || pageContent['/about'][lang];

  return {
    ...page,
    canonicalPath: `/#${pathname}`
  };
}

export { homeDescription };